export const trainersImages = [
  {
    name: "Content Marketing and Social Media Course",
    description: "16 Weeks | Part-Time",
    link: "https://www.kraftshala.com/content-writing-course/",
  },

  {
    name: "Digital Marketing Course - Weekends",
    description: "48 Weeks | Part-Time",
    link:
      "https://www.kraftshala.com/marketing-launchpad/part-time-digital-marketing-course/",
  },
];
